export default __webpack_public_path__ + "static/summit_stars_4_3-f357ffa73ea0814f301ea113c70b139a.svg";